import { Popup } from '@progress/kendo-react-popup';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { POPUP_PLUS_PROPS } from './Types';

class PopupPlus extends React.Component<POPUP_PLUS_PROPS, {}> {
  private stopCloseEl: boolean = false;
  private popupShow: boolean = false;
  private autoHiddenShow: boolean = true;
  private listenerHandlers: any = {};
  private baseComponentCfg: any;

  componentDidMount() {
    if (this.props.autoHidden) {
      this.listenerHandlers.clickBodyEvent = this.clickBodyEvent.bind(this);
      document.body.addEventListener('click', this.listenerHandlers.clickBodyEvent, true);
    }
  }

  componentDidUpdate(prevProps: Readonly<POPUP_PLUS_PROPS>, prevState: Readonly<{}>, snapshot?: any) {
    if (this.props.autoHidden) {
      this.autoHiddenShow = true;
    }
  }

  componentWillUnmount() {
    if (this.props.autoHidden) {
      document.body.removeEventListener('click', this.listenerHandlers.clickBodyEvent, true);
      delete this.listenerHandlers.clickBodyEvent;
    }
  }

  private setReallyState = () => {
    const propName = _.get(this, 'baseComponentCfg.propName');
    if (propName) {
      _.set(this, `baseComponentCfg.cmp.state.${propName}`, this.popupShow);
    }
  }

  setBaseComponentCfg = (baseCmp: any, propName: string) => {
    this.baseComponentCfg = {
      cmp: baseCmp,
      propName: propName
    };
  }

  private clickBodyEvent = (e: MouseEvent) => {
    setTimeout(() => {
      if (!this.stopCloseEl) {
        let isClickedPopup = false;
        const popupEl = this.getHtmlElement(this);
        if (popupEl) {
          const rect = popupEl.getBoundingClientRect();
          isClickedPopup = e.clientX > rect.left && e.clientX < rect.right && e.clientY > rect.top && e.clientY < rect.bottom;
        }
        if (popupEl && !isClickedPopup) {
          this.autoHiddenShow = false;
          this.setState({
            show: false
          });
        }
      }
      this.stopCloseEl = false;
    }, 1);
  }

  private getHtmlElement = (source: any): HTMLElement | null => {
    try {
      return ReactDOM.findDOMNode(source as React.ReactInstance) as HTMLElement;
    } catch (e) {
      return null;
    }
  };

  private isPopupShow = (): boolean => {
    let popupShow = this.props.show;
    if (this.props.autoHidden) {
      popupShow = this.props.show && this.autoHiddenShow;
    }
    return !!popupShow;
  }

  render() {
    this.popupShow = this.isPopupShow();
    this.setReallyState();
    return (
      <Popup
        {...this.props}
        show={this.popupShow}
      />
    );
  }
}

export default PopupPlus;
